module.exports = __webpack_public_path__ + "img/Banner.1d64c2d.jpg";